var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-data-table',{attrs:{"headers":_vm.header,"items":_vm.items,"sort-by":"key","sort-desc":"","items-per-page":"5"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }